import type { SignInToWatchItem } from '~/features/signin-to-watch'

import { combine, createEvent, createStore, restore, sample } from 'effector'
import { COMPONENT, register } from '~/core/repository'
import {
  $signInToWatchTranslations,
  siginInToWatchFeatureModel,
} from '~/features/signin-to-watch'
import { F, T } from '~/shared/helpers'
import { DescriptionWithLink } from './DescriptionWithLink'

export const openSignInToWatchPopup = createEvent<SignInToWatchItem>()
export const closeSignInToWatchPopup = createEvent()

const $showPopup = createStore<boolean>(false)
  .on(openSignInToWatchPopup, T)
  .on(closeSignInToWatchPopup, F)

const $title = siginInToWatchFeatureModel.$signInToWatchItem.map((item) =>
  item ? item.name : ''
)

// Means popup blocked from showing
export const setBlocked = createEvent<boolean>()
export const $isBlocked = restore(setBlocked, false)

// popup showing state
const $isOpened = combine(
  $showPopup,
  siginInToWatchFeatureModel.$signInToWatchItem,
  $isBlocked,
  (showPopup, item, isBlocked) =>
    isBlocked ? false : showPopup && Boolean(item)
)

sample({
  clock: openSignInToWatchPopup,
  target: siginInToWatchFeatureModel.$signInToWatchItem,
})

sample({
  clock: closeSignInToWatchPopup,
  target: siginInToWatchFeatureModel.resetSignInToWatchItem,
})

register(
  $signInToWatchTranslations,
  '$signInToWatchPopupWidget/signInToWatchTranslations'
)
register($isOpened, '$siginInToWatchFeature/isOpened')
register($title, '$siginInToWatchFeature/title')
register(
  siginInToWatchFeatureModel.signInToWatch, // submit handler
  'siginInToWatchFeature/signInToWatch'
)
register(openSignInToWatchPopup, 'siginInToWatchFeature/openSignInToWatchPopup')
register(
  closeSignInToWatchPopup,
  'siginInToWatchFeature/closeSignInToWatchPopup'
)
register(DescriptionWithLink, 'DescriptionWithLink', COMPONENT)
